import { ApiError } from '@/lib/api';
import { translateApiError } from '@/lib/apiError';

/** A failed issue, in words the person at the dispensing desk can act on. */
export function humaniseIssueError(err: unknown, t: (key: string, opts?: Record<string, unknown>) => string): string {
  if (err instanceof ApiError) {
    if (err.code === 'INSUFFICIENT_STOCK') {
      return t('issue.errInsufficient', { message: translateApiError(err) });
    }
    if (err.code === 'VALIDATION_ERROR') return t('issue.errInvalidLines');
    return translateApiError(err);
  }
  return t('issue.errSubmitFailed');
}
